import { render, staticRenderFns } from "./_productsTable.vue?vue&type=template&id=2bc4f160"
import script from "./_productsTable.vue?vue&type=script&lang=js"
export * from "./_productsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports